
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ConicMask from '../../components/circlePress.vue';

interface ProgressItem {
  value: number;
  label: string;
  color: string;
  config: any;
}

@Component({
  components: {
    ConicMask
  }
})
export default class NavigationCircle extends Vue {
  @Prop({ type: Object, required: true }) readonly analysisList!: any;

  private progressItems: ProgressItem[] = [];

  created() {
    this.updateProgressItems();
  }

  @Watch('analysisList', { deep: true })
  onAnalysisListChanged() {
    this.updateProgressItems();
  }

  private updateProgressItems() {
    this.progressItems = [
      {
        value: this.analysisList.shouldArriveNum,
        label: '应到学生',
        color: '#e45739',
        config: {
          borderWidth: "3px",
          circleSize: "10px",
          circleColor: "#e4573978",
          borderColor: "#d5f4ee",
          startColor: "#eead99",
          endColor: "#e45739",
          borderBackground: "#d6e4f159",
          centerCircleBg: "#fff",
          clockwise: true,
          showEyes: true,
          eyesSize: "5px",
        }
      },
      {
        value: this.analysisList.actualArriveNum,
        label: '实到学生',
        color: '#50eb6a',
        config: {
          borderWidth: "3px",
          circleSize: "10px",
          circleColor: "#11b95c9e",
          borderColor: "#d5f4ee",
          startColor: "#dbf5d5",
          endColor: "#50eb6a",
          borderBackground: "#d6e4f159",
          centerCircleBg: "#fff",
          clockwise: true,
          showEyes: true,
          eyesSize: "5px",
        }
      },
      {
        value: this.analysisList.leaveCompassionateNum+this.analysisList.sickLeaveNum,
        label: '请假学生',
        color: '#1682e6',
        config: {
          borderWidth: "3px",
          circleSize: "10px",
          circleColor: "#1682e6ba",
          borderColor: "#d5f4ee",
          startColor: "#a8cae9",
          endColor: "#1682e6",
          borderBackground: "#d6e4f159",
          centerCircleBg: "#fff",
          clockwise: true,
          showEyes: true,
          eyesSize: "5px",
        }
      },
      {
        value: this.analysisList.notReportedStudentNum,
        label: '未打卡学生',
        color: '#fff',
        config: {
          borderWidth: "3px",
          circleSize: "10px",
          circleColor: "#ffffff38",
          borderColor: "#d5f4ee",
          startColor: "#f5f7fa03",
          endColor: "#fff",
          borderBackground: "#d6e4f159",
          centerCircleBg: "#fff",
          clockwise: true,
          showEyes: true,
          eyesSize: "5px",
        }
      },
    ];
  }

  private getRate(value: number): number {
    const maxValue = Math.max(
      this.analysisList.shouldArriveNum,
      this.analysisList.actualArriveNum,
      this.analysisList.sickLeaveNum+this.analysisList.leaveCompassionateNum,
      this.analysisList.notReportedStudentNum
    );
    return maxValue > 0 ? value / maxValue : 0;
  }
}
